import { postFetch } from '../fetch';
import { apiConfig } from '../config';

interface PutRunCodeParams {
    image: 'PYTHON' | 'PYTHON_BLOCKLY_MIPT_ML';
    user_code: string;
    user_input?: string[];
    pre_user_code?: string;
    post_user_code?: string;
    env?: Record<string, string>;
}

interface PutRunCodeResponse {
    status: CHECK_DETAILS_STATUS;
    output: string;
    exception_line: number | null;
    exception_offset: number | null;
    exception_type: string | null;
    exception_message: string | null;
    exception_traceback: string | null;
}

enum CHECK_DETAILS_STATUS {
    EXCEPTION = 'exception',
    MISTAKE = 'mistake',
    OK = 'ok',
}

export function putRunCode<_T>(params: PutRunCodeParams): Promise<PutRunCodeResponse> {
    const { apiPutRunCode } = apiConfig.getStaticUrls();

    return postFetch(apiPutRunCode, params);
}
